module.exports = __webpack_public_path__ + "static/media/videoHome3.a3267ee2.mov";